import OrganizationDetail from './OrganizationDetail';

export default OrganizationDetail;
